export class TransactionUtils {
  static getStatusColor(status: string) {
    switch (status) {
      case "pending":
        return "text-warning";
      case "successful":
        return "text-success";
      case "cancelled":
        return "text-gray";
      case "failed":
        return "text-red";
      default:
        return "text-black";
    }
  }
}
